import React from 'react';

const SVGRenderer = ({ svgString }) => {
  if (!svgString) return null;
  
  // Konvertiere className zu class im SVG-String
  const processedSvgString = svgString.replace(/className=/g, 'class=');
  
  const div = document.createElement('div');
  div.innerHTML = processedSvgString;
  
  const svgElement = div.querySelector('svg');
  if (!svgElement) return null;

  // Konvertiere Attribute in React-kompatible Form
  const convertAttributes = (element) => {
    const attrs = {};
    Array.from(element.attributes).forEach(attr => {
        attrs.className = 'card-svg';
        attrs.fill = 'currentColor';
      switch(attr.name) {
        case 'xml:space':
          attrs.xmlSpace = attr.value;
          break;
        case 'style':
          try {
            // Versuche den style-String zu parsen
            const styleObj = {};
            attr.value.split(';')
              .filter(style => style.length > 0)
              .forEach(style => {
                const [key, value] = style.split(':');
                if (key && value) {
                  const camelKey = key.trim()
                    .replace(/-([a-z])/g, g => g[1].toUpperCase());
                  styleObj[camelKey] = value.trim();
                }
              });
            attrs.style = styleObj;
          } catch (e) {
            console.warn('Style parsing failed:', e);
            attrs.style = {};
          }
          break;
        default:
          // Konvertiere data-* Attribute
          if (attr.name.startsWith('data-')) {
            attrs[attr.name] = attr.value;
          } else {
            // Konvertiere kebab-case zu camelCase für andere Attribute
            const attrName = attr.name.replace(/-([a-z])/g, g => g[1].toUpperCase());
            attrs[attrName] = attr.value;
          }
      }
    });
    return attrs;
  };

  const createChildren = (element) => {
    return Array.from(element.children).map((child, index) => (
      React.createElement(
        child.tagName.toLowerCase(),
        {
          ...convertAttributes(child),
          key: index
        },
        child.children.length > 0 ? createChildren(child) : null
      )
    ));
  };

  return React.createElement(
    'svg',
    convertAttributes(svgElement),
    createChildren(svgElement)
  );
};

export default SVGRenderer;
